import {VariantOptionsEntity} from "@/entity/VariantOptionsEntity";

export class globalProductSettings {
    product_property_group_id : number | null = null;
    name:string = "";
    selected_product_property_id:number | null = null;
}
export class ProductProperties {
    product_properties_id : number | null = null;
    width: number | null = null;
    height: number | null = null;
    name: string =  "";
    ex_price:number | null = null;
    price: number | null = null;
    product_property_group_id!: number;
    min_sell_piece: number | null = null;
    no: number | null = null;
    enabled: number | null = null;
    print_info: number | null = null;
    created_at: string | null = null;
    updated_at: string | null = null;
}
export class ProductEntity {
    "product_id"!:number;
    "cat_id"!:number;
    "seo_id":number = 1;//otomatik
    "product_images_id":number = 0;
    "design_data":[] =[];
    "name"!:string;
    "description"!:string;
    "image_origin":string = "";
    "image_wm"!:string;
    "homepage_enabled"!:number;
    "detail_enabled"!:number
    "menu_enabled"!:number;
    "image_wm_thumb"!:string;
    "image_show":string = "";
    "image_show_thumb":string="";
    "ex_price"!:number;
    "special_price"!:number;
    "price"!:number;
    "hit"!:number;
    "sold"!:number;
    "stock"!:number | null;
    "stock_code"!:string;
    "enabled":number = 1;
    "same_day_packet":number = 0;
    "one_day_packet":number = 0;
    "free_cargo":number = 0;
    "image_width":number;
    "image_height":number;
    "deleted":number = 0;
    "no":number | null = null;
    unsearchable:number | null = null;
    cost!:number;
    total_stock!:number;
    cargo_day!:number;
    sozlesme_id!:number;
    "created_at"!:string;
    "updated_at"!:string;
    product_categories:[]=[];
    variant_options:VariantOptionsEntity[] = [];
    product_sku_id:any;
    offer_data:any[] = [];
}
export class productGroup {
    product_group_id!:number;
    name!:string;
    created_at!:string;
    updated_at!:string;
}
export class productGroupList {
    product_group_list_id!:number;
    product_group_id!:number;
    product_property_group_id!:number;
    created_at!:string;
    updated_at!:string;
}
export class ProductImages {
    "product_images_id"!:number;
    "product_id"!:number;
    "image_url"!:string;
    "thumb_url"!:string;
    "created_at"!:string;
    "updated_at"!:string;
}